<nz-skeleton
  [nzActive]="true"
  [nzLoading]="isDesignLoading"
  [ngClass]="{ 'em-skeleton-white-background': isDesignLoading }"
>
  <ng-container *ngFor="let item of siriusElementHistoryDocuments$ | async; trackBy: trackByRef">
    <em-share-point-file-link-card
      [loading]="(siriusElementHistoryDocumentsLoading$ | async) ?? false"
      [error]="(error$ | async) ?? ''"
      title="Sirius Element History Document"
      [item]="item"
    ></em-share-point-file-link-card>
  </ng-container>
</nz-skeleton>
